"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/spin/style/css");

var _spin = _interopRequireDefault(require("antd/es/spin"));

var _Column = _interopRequireDefault(require("antd/es/table/Column"));

var _react = _interopRequireWildcard(require("react"));

var _reactCsv = require("react-csv");

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _reselect = require("reselect");

var _Util = require("../../components/util/Util");

var _analytics = require("../../redux/analitycs/analytics.types");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./report.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const initialState = {};

class IncentivesReport extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.rowClassName = (record, index) => {
      return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
    };
  }

  componentDidMount() {
    this.props.getAnalyticsReport();
  }

  render() {
    const {
      analytics,
      getAnalyticsReportStatus
    } = this.props;

    if (getAnalyticsReportStatus.isLoading) {
      return /*#__PURE__*/_react.default.createElement(_spin.default, null);
    }

    const headers = [{
      label: 'ParticipantId',
      key: 'participantId'
    }, {
      label: 'Study Arm Id',
      key: 'studyArmId'
    }, {
      label: 'Status',
      key: 'hivStatus'
    }, {
      label: 'Create Date',
      key: 'createDate'
    }, {
      label: 'Event Type',
      key: 'eventType'
    }, {
      label: 'Meta',
      key: 'meta'
    }];
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, {
      data: analytics,
      headers: headers,
      filename: `Analytics-Report-${(0, _Util.renderDateWithoutTime)(new Date())}`
    }, /*#__PURE__*/_react.default.createElement(_button.default, null, "Export as CSV")), /*#__PURE__*/_react.default.createElement(_table.default, Object.assign({}, this.state, {
      style: {
        paddingTop: '10px'
      },
      dataSource: analytics,
      rowClassName: this.rowClassName,
      rowKey: "incentivePaymentId",
      scroll: {
        y: 'calc(100vh - 200px)'
      },
      pagination: false
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Participant Id",
      dataIndex: "participantId",
      key: "participantId",
      sorter: (a, b) => a.participantId - b.participantId
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Study Arm Id",
      dataIndex: "studyArmId",
      key: "studyArmId",
      sorter: (a, b) => a.studyArmId - b.studyArmId
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Status",
      dataIndex: "hivStatus",
      key: "hivStatus",
      sorter: (a, b) => a.hivStatus - b.hivStatus
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Create Date",
      dataIndex: "createDate",
      key: "createDate",
      render: paidDate => `${paidDate ? (0, _Util.renderDateWithTime)(paidDate) : ''}`,
      defaultSortOrder: "descend"
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Event Type",
      dataIndex: "eventType",
      key: "eventType"
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: "Meta",
      dataIndex: "meta",
      key: "meta"
    })));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  analytics: selectors.getAnalytics,
  getAnalyticsReportStatus: selectors.getAnalyticsReportStatus
});

const mapDispatchToProps = dispatch => {
  return {
    getAnalyticsReport: () => dispatch(_analytics.getAnalyticsReportAsync.request())
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(IncentivesReport));

exports.default = _default;